<template>
  <el-dialog
    :title="item.RoleName"
    :visible.sync="visible"
    append-to-body
    v-dialogDrag
    width="500px"
    top="30px"
    :close-on-click-modal="false"
  >
    <div class="RoleTreeBody">
      <el-tree
        check-strictly
        :default-expand-all="true"
        :data="treeData"
        show-checkbox
        check-on-click-node
        :expand-on-click-node="false"
        node-key="PowerId"
        ref="tree"
        :props="{ label: 'PowerName' }"
      ></el-tree>
    </div>
    <span slot="footer">
      <el-button type="canale" @click="visible = false">关闭</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      visible: false,
      treeData: [],
    };
  },
  watch: {
    item(v) {
      this.visible = true;
      this.$nextTick(() => {
        this.$get("Power/GetPowerIDByRole", {
          RoleId: v.RoleId,
        }).then((r) => {
          let list =r.Result.PowerId;
          this.$refs.tree.setCheckedKeys([...list]);
        });
      });
    },
  },
  mounted() {
    this.$get("Power/GetList", {
      IsEnable: "1",
    }).then((r) => {
      let treeData = this.$g.listToTree(r.Result, "PowerId", "PowerParent");
      this.treeData = treeData;
    });
  },
  methods: {
    save() {
      let fullPermission = this.$refs.tree.getCheckedKeys();
      if (fullPermission.length == 0) {
        this.$message.error("请选择权限");
        return;
      }
      this.$post("Power/AddPowerByRole", {
        RoleId: this.item.RoleId,
        PowerId: fullPermission,
      }).then((r) => {
        this.$message.success("操作成功");
        this.$emit("success");
        this.visible = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.RoleTreeBody{
  height: 400px;
  overflow-y: auto;
}
</style>